import React, { useEffect, useState } from 'react'
import AnimationStyle from './AnimationStyle'

const images = [
  "./1.jpg",
  "./2.jpg",
  "./3.jpg",
  "./4.jpg",
  "./5.jpg",
  "./6.jpg"
]

const texts = [
  "Arqelio: Where Vision Meets Execution.",
  "From Blueprint to Delivery - We Build, Move, and Manage it All.",
  "Construction. Consulting. Logistics. One Trusted Partner.",
  "We Don’t Just Build — We Engineer Success.",
  "Your trusted partner in construction and real estate development",
  "Seamless Solutions for Complex Projects.",
]

const Hero = () => {

  // State to manage the current image index and the text index for the slider
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentTextIndex, setCurrentTextIndex] = useState(0);

  // Function to change the image and text index every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 4000); // Change every 4 seconds

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, []);


  // Inline styles for the text overlay
  const transitionStyles = [
    "animate-slideInLeft",
    "animate-slideInRight",
    "animate-slideInTop",
    "animate-slideInBottom",
    "animate-fadeIn",
  ];



  return (
    <section className="relative h-[60vh] md:h-[80vh] overflow-hidden">
      {/* The background image */}
      <div
        className="absolute inset-0 bg-cover bg-center filter blur-lg scale-110"
        style={{ background: `url(${images[4]})` }} // the first image as blurred background
      >
      </div>

      {/* The static image slider */}
      <div className="relative w-full h-full">
        <img
          src={images[currentImageIndex]} // Displays the current image from the slider
          alt={`Slide ${currentImageIndex}`}
          className={`w-full h-full object-cover ${transitionStyles[currentImageIndex % transitionStyles.length]}`}
        />
      </div>

      {/* The Black overlay with 80% Opacity */}
      <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50 z-0">
      </div>

      {/* The centered text over the image with dynamic adjutments */}
      <div className="absolute inset-0 flex justify-center items-center z-10 text-white text-center px-6 sm:px-12">
        <div className="text-4xl sm:text-6xl font-semibold max-w-full sm:max-w-3xl">
          <div
            className="mb-4"
            style={{
              whiteSpace: 'normal',
              lineHeight: '1.5',
              wordWrap: 'break-word',
              animationDelay: '0.5s', // delay to allow the text to appear smoothly
              // Adding some custom margins for mobile view to avoid text being too high
              marginTop: '10%',  // Adjusted for mobile screens
              marginBottom: '10%' // To ensure text doesn't go too high or low
            }}          
          >
            {texts[currentTextIndex]} {/*  Displays the current text from the slider */}
          </div>
        </div>
      </div>

      {/* The css animation of the hero section */}
      <AnimationStyle />
    </section>
  )
}

export default Hero